/**
 * The Events section (spec sections 38-45, 57, 62, 63).
 *
 * Every operation here can now be scheduled, rostered and cancelled for real —
 * that part of the API is live. What is still missing per type is the planner:
 * the AC lane optimizer, the Swordland legion builder, the Fortress stagger.
 *
 * Each page names its own missing piece rather than sharing one vague notice,
 * because the gaps are genuinely different sizes and an R4 planning a week
 * ahead should be able to tell which tool they will and will not have.
 *
 * The operation names stay in English in both locales — Korean players say
 * "Bear Trap" and "Swordland" out loud, and a translated name would make the
 * screen harder to match against the game.
 */

import { EventTypePage } from './EventTypePage';
import { PageHeader, Notice } from '../../components/ui/primitives';
import { NotAvailableYet } from '../../components/ui/states';
import { useT } from '../../i18n';

export function ChampionshipPage() {
  const t = useT();
  return (
    <EventTypePage
      eventType="ALLIANCE_CHAMPIONSHIP"
      title={t.events.championship.title}
      subtitle={t.events.championship.subtitle}
      plannerNote={t.events.championship.plannerNote}
      plannerPhase={t.events.championship.plannerPhase}
    />
  );
}

export function SwordlandPage() {
  const t = useT();
  return (
    <EventTypePage
      eventType="SWORDLAND"
      title={t.events.swordland.title}
      subtitle={t.events.swordland.subtitle}
      plannerNote={t.events.swordland.plannerNote}
      plannerPhase={t.events.swordland.plannerPhase}
    />
  );
}

export function FortressPage() {
  const t = useT();
  return (
    <EventTypePage
      eventType="FORTRESS"
      title={t.events.fortress.title}
      subtitle={t.events.fortress.subtitle}
      plannerNote={t.events.fortress.plannerNote}
      plannerPhase={t.events.fortress.plannerPhase}
    />
  );
}

export function CastlePage() {
  const t = useT();
  return (
    <EventTypePage
      eventType="CASTLE"
      title={t.events.castle.title}
      subtitle={t.events.castle.subtitle}
      plannerNote={t.events.castle.plannerNote}
      plannerPhase={t.events.castle.plannerPhase}
    />
  );
}

export function VikingPage() {
  const t = useT();
  return (
    <EventTypePage
      eventType="VIKING_VENGEANCE"
      title={t.events.viking.title}
      subtitle={t.events.viking.subtitle}
      plannerNote={t.events.viking.plannerNote}
      plannerPhase={t.events.viking.plannerPhase}
    />
  );
}

export function TriAlliancePage() {
  const t = useT();
  return (
    <EventTypePage
      eventType="TRI_ALLIANCE_CLASH"
      title={t.events.triAlliance.title}
      subtitle={t.events.triAlliance.subtitle}
      plannerNote={t.events.triAlliance.plannerNote}
      plannerPhase={t.events.triAlliance.plannerPhase}
    />
  );
}

export function MobilizationPage() {
  const t = useT();
  return (
    <EventTypePage
      eventType="ALLIANCE_MOBILIZATION"
      title={t.events.mobilization.title}
      subtitle={t.events.mobilization.subtitle}
      plannerNote={t.events.mobilization.plannerNote}
      plannerPhase={t.events.mobilization.plannerPhase}
    />
  );
}

export function BearExperimentsPage() {
  const t = useT();
  return (
    <>
      <PageHeader title={t.events.experiments.title} subtitle={t.events.experiments.subtitle} />
      <Notice severity="INFO">{t.events.experiments.notice}</Notice>
      <div style={{ marginTop: 12 }}>
        <NotAvailableYet
          feature={t.events.experiments.feature}
          phase={t.events.experiments.phase}
          describes={t.events.experiments.describes}
        />
      </div>
    </>
  );
}
